export default __webpack_public_path__ + "static/media/construction-building.78607785.jpg";